import React, {useState} from "react";
import {Grid, TextField, Button, MenuItem, IconButton, Autocomplete} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {AuctionType, PlanState} from "../../../../utils/enums";
import {PlansFilterParams, SearchFunction} from "../../../../types/plan";
import {useDictionary} from "../../../../utils/useDictionary";

const FilterPanel = ({t, onSearch}: { t: any, onSearch: SearchFunction<PlansFilterParams> }) => {
    // const currentYear = new Date().getFullYear()

    const [year, setYear] = useState<number | null>(null);

    const planState = useDictionary(
        PlanState,
        (type) => ({value: type, label: t(`plan_state.${type}`)}),
        {value: '', label: ''}
    );

    const onClearYear = () => setYear(null);

    const handleSearch = () => {
        const filters: PlansFilterParams = {year, state: (planState?.selected?.value || null) as PlanState};
        onSearch(filters);
    };

    const handleClear = () => {
        setYear(null);
        planState.setSelected({value: '', label: ''})
        onSearch({year: null, state: null});
    };

    const emptyOption = {value: "", label: ""};
    const dictionaryWithEmpty = [emptyOption, ...planState.dictionary];

    return (
        <Grid container marginBottom={2} spacing={2} alignItems="center">

            {/* Выбор года */}
            <Grid item xs={12} sm={3} md={2} lg={2}>
                <TextField
                    fullWidth
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={t("cabinet.plans.filter.financial_year")}
                    type="number"
                    value={year ?? ''}
                    onChange={(e) => setYear(parseInt(e.target.value))}
                    InputProps={{
                        endAdornment: year ? (
                            <IconButton size="small" onClick={onClearYear}>
                                <ClearIcon/>
                            </IconButton>
                        ) : undefined,
                    }}
                />
            </Grid>

            {/* Выбор типа из выпадающего списка */}
            <Grid item xs={12} sm={3} md={2} lg={2}>
                <Autocomplete
                    disablePortal size="small" sx={{mb: .5}}
                    options={dictionaryWithEmpty}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={planState.selected}
                    onChange={planState.onSelectChange}
                    fullWidth
                    renderInput={params =>
                        <TextField {...params} fullWidth color="primary"
                                   name="planState" label={t("cabinet.plans.filter.status")}
                        />
                    }
                />
            </Grid>

            {/* Кнопка для поиска */}
            <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={handleSearch}
                    size={'small'}
                >
                    {t("common.search")}
                </Button>
            </Grid>
            <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={handleClear}
                    size={'small'}
                >
                    {t("common.clear")}
                </Button>
            </Grid>
        </Grid>
    );
};

export default FilterPanel;